export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["نوع العنوان"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["نوع الحساب"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["العملة"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الاسم"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إنشاء عنوان"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إنشاء حساب"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إنشاء عنوان جديد"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إنشاء حساب جديد"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل الاسم"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اختر العملة"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إنشاء"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إلغاء"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اختر النوع"])}
}